import { observer } from "mobx-react-lite"
import { useAccount } from "wagmi"

import { useScaleApplication } from "@/domains/application/use-scale-application"

const ADMIN_ADDRESSES = [
  "0xC606e3D6C5dd451aB79B554d3A560833FFF2E5Dc".toLowerCase(),
  "0xA740522eCaff98D1F2eBB29d5CAA19Fd4cF5D92F".toLowerCase(),
]

export const AdminThemeToggle = observer(() => {
  const { address } = useAccount()

  try {
    const scaleApp = useScaleApplication()

    // Check if connected address is an admin
    const isAdmin = address && ADMIN_ADDRESSES.includes(address.toLowerCase())

    if (!isAdmin || !scaleApp?.Settings) {
      return null
    }

    const handleToggle = () => {
      scaleApp.Settings.setThemeModeEnabled(!scaleApp.Settings.themeModeEnabled)
    }

    return (
      <label className="flex cursor-pointer items-center gap-2">
        <input
          type="checkbox"
          checked={scaleApp.Settings.themeModeEnabled}
          onChange={handleToggle}
          className="h-4 w-4 cursor-pointer rounded border-secondary-700 bg-secondary-800 text-primary-600 focus:ring-primary-500"
          title="Toggle Theme Editor"
        />
        <span className="text-xs text-secondary-300">Theme</span>
      </label>
    )
  } catch {
    // App not initialized yet
    return null
  }
})

